import { render, staticRenderFns } from "./QuestionAddress.vue?vue&type=template&id=23d017dc&scoped=true&"
import script from "./QuestionAddress.vue?vue&type=script&lang=js&"
export * from "./QuestionAddress.vue?vue&type=script&lang=js&"
import style0 from "./QuestionAddress.vue?vue&type=style&index=0&id=23d017dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d017dc",
  null
  
)

export default component.exports